import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgPh = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "b",
      width: 24,
      height: 24,
      x: 0,
      y: 0,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#0038A8",
        d: "M0 0h24v12H0z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#CE1126",
        d: "M0 12h24v12H0z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M20.784 12 0 24V0"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FCD116",
        d: "m1.181 2.081.722.624.84-.46-.376.877.703.656-.96-.08-.404.863-.22-.928-.947-.122.82-.492zm16.261 8.653.019.952.905.314-.905.314-.019.952-.576-.76-.915.281L16.5 12l-.549-.783.915.277zM1.711 19.44l.403.863.952-.08-.694.656.37.877-.839-.46-.722.624.183-.938-.82-.492.947-.122zM7.448 6.938l-.309.309.15 2.358-.155.014-.28-2.152-.259.253.385 1.922a2.4 2.4 0 0 0-.863.361L5.025 8.372h-.36l1.32 1.725-.116.098-1.561-1.78h-.44v.444l1.78 1.561-.103.117L3.82 9.216v.36l1.632 1.093a2.4 2.4 0 0 0-.357.862l-1.922-.384-.257.258 2.156.281-.019.16-2.358-.155-.314.309.314.31 2.358-.15.014.154-2.151.281.253.258 1.922-.384a2.4 2.4 0 0 0 .36.862l-1.63 1.093v.36l1.724-1.322.099.118-1.782 1.56v.441h.45L5.873 13.8l.118.103-1.322 1.725h.36l1.093-1.631c.261.174.554.296.862.356L6.6 16.275l.258.258.281-2.156.155.018-.15 2.358.31.314.309-.314-.15-2.358.154-.014.281 2.152.258-.253-.384-1.922c.308-.063.601-.185.862-.361l1.093 1.631h.36l-1.33-1.725.116-.098 1.561 1.781h.441v-.445L9.244 13.58l.103-.117 1.725 1.321v-.36L9.44 13.33c.174-.261.295-.554.356-.862l1.922.384.258-.258-2.157-.28.019-.156 2.358.15.314-.309-.314-.31-2.358.155c0-.056-.01-.107-.014-.159l2.152-.281-.254-.258-1.921.384a2.4 2.4 0 0 0-.361-.862l1.63-1.092v-.361l-1.724 1.322-.099-.118 1.782-1.56v-.441h-.446L9.024 10.2l-.118-.103 1.322-1.725h-.36l-1.093 1.631a2.4 2.4 0 0 0-.863-.356l.385-1.922-.258-.258-.281 2.157-.155-.02.15-2.357z"
      })]
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgPh;